var firebaseConfig = {
  apiKey: "AIzaSyAMynj99C-dR4PJA6Xx7DRixr7yfCUUknE",
  authDomain: "myst-fish.firebaseapp.com",
  databaseURL: "https://myst-fish.firebaseio.com",
  projectId: "myst-fish",
  storageBucket: "myst-fish.appspot.com",
  messagingSenderId: "988503286225",
  appId: "1:988503286225:web:46fceec7daa9447f4340f0",
  measurementId: "G-9TTRP51HEV"
};


export default firebaseConfig;

